// shared/src/schemas/basket-prediction.ts
// Zod schema for `basket_predictions` table — V2 narrow + JSON details
// (migration 0021). 7 columns: scoring contract (horizon_days +
// predicted_alignment) + meta (schema_version) + display details JSON.
//
// predicted_bias_distribution and a.1.synthesis prose (cross_ticker_paradoxes,
// synthesis_prose) live under `details` JSON sidecar per §K.1 — only the
// alignment + horizon are indexed for downstream scoring.

import { z } from 'zod';

export const BasketPredictionSchema = z.object({
  id:                  z.string(),
  brief_id:            z.string(),
  horizon_days:        z.number().int().positive(),
  predicted_alignment: z.string(),                       // JSON: [{ticker, alignment ∈ 'long'|'short'|'flat'}]
  schema_version:      z.number().int(),
  details:             z.string(),                       // JSON: { predicted_bias_distribution, a_synthesis? }
  created_at:          z.string().datetime(),
});

export type BasketPrediction = z.infer<typeof BasketPredictionSchema>;
